function NoIssuesFound(props){
    return(
        <div className="no-issues">
            <span>No Issues Found! <i class="fa fa-smile-o" aria-hidden="true"></i> </span>
        </div>
    )
}

export default NoIssuesFound